import styled from 'styled-components';

const CardWrapper = styled.div`
  background-color: white;
  padding: 30px;
  margin-bottom: 10px;
  height: fit-content;
  text-align: left;
`;

const ContactWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: #fff;
  padding: 30px;
`;

const CenterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 30px;
`;

const AdsRightSectionWrapper = styled.div``;

export { CardWrapper, ContactWrapper, AdsRightSectionWrapper, CenterWrapper };
